import classNames from 'classnames';

import pievilleIcon from '@/icons/android-chrome-192x192.png';
import pievilleWordmarkDark from '@/images/pieville-wordmark-dark.png';
import pievilleWordmark from '@/images/pieville-wordmark.png';

// Two rasters (dark text / light text); CSS shows whichever fits the theme.
export const WordmarkLogo: React.FC = () => (
  <>
    <img
      src={pievilleWordmark}
      alt='Pieville'
      className='logo logo--wordmark logo--wordmark-light'
    />
    <img
      src={pievilleWordmarkDark}
      alt=''
      aria-hidden='true'
      className='logo logo--wordmark logo--wordmark-dark'
    />
  </>
);

export const IconLogo: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox='0 0 79 79'
    className={classNames('logo logo--icon', className)}
    role='img'
  >
    <title>Pieville</title>
    <use xlinkHref='#logo-symbol-icon' />
  </svg>
);

export const SymbolLogo: React.FC = () => (
  <img src={pievilleIcon} alt='Pieville' className='logo logo--icon' />
);
